import axios from 'axios'
import { _ } from '../utils'
import config from './../config/main'
import { handleError } from '../utils/error-handler'

export class CharityBox {

    constructor(el) {
        this.el = el
        this.toggler = _('toggle', 'element').nodeFrom(this.el)
        this.showableElements = _('show-element').nodesFrom(this.el)
        this.hidableElements = _('hide-element').nodesFrom(this.el)
        this.increment = _('increment', 'element').nodeFrom(this.el)
        this.decrement = _('decrement', 'element').nodeFrom(this.el)
        this.errorContainer = _('error-container', 'element').nodeFrom(this.el)
        this.charityName = el.dataset.charityName
        this.charityNumber = el.dataset.charityNumber
        this.charityLogo = el.dataset.charityLogo
        this.penniesLogo = el.dataset.penniesLogo
        this.donationBase = _('base-donation', 'element').nodeFrom(this.el)
        this.donationTotal = _('number-control-input', 'element').nodeFrom(this.el)
        this.donationQuantity = _('multiplier', 'element').nodeFrom(this.el)
        this.loadingContainer = _('target-loading-container', 'element').node()
        this.basketDonationSummary = _('basket-donation-summary', 'element').node()

        this.showableElements?.forEach((elem) => {
            elem.style.display = 'none'
        })

        this.toggler?.addEventListener('change', () => {
            this.toggleElements()
        })

        // Show donations on page reload.
        if (this.toggler.checked) {
            this.toggleElements()
        }

        this.increment?.addEventListener('click', () => {
            this.handleIncrementDecrement(false)
        })

        this.decrement?.addEventListener('click', () => {
            this.handleIncrementDecrement(false)
        })
    }

    toggleElements = () => {
        if (this.toggler.checked) {
            this.handleIncrementDecrement({
                toggleChecked: true,
                resetDonation: false
            })

            this.basketDonationSummary?.classList.remove('u-hidden')

            this.hidableElements?.forEach((el) => {
                el.style.display = 'none'
            })
            this.showableElements?.forEach((el) => {
                el.style.display = 'block'
            })
        } else {
            this.handleIncrementDecrement({
                toggleChecked: false,
                resetDonation: true
            })

            this.basketDonationSummary?.classList.add('u-hidden')

            this.hidableElements?.forEach((el) => {
                el.style.display = 'block'
            })
            this.showableElements?.forEach((el) => {
                el.style.display = 'none'
            })
        }
    }

    handleIncrementDecrement = ({ toggleChecked, resetDonation }) => {
        const formData = new FormData()
        formData.append('baseDonation', this.donationBase?.innerHTML)
        formData.append('charityNo', this.charityNumber)
        formData.append('charityName', this.charityName)
        formData.append('charityLogo', this.charityLogo)
        formData.append('penniesLogo', this.penniesLogo)
        formData.append('total', this.donationTotal.value)

        // If donations are deselected, reset quantity to 0.
        if (resetDonation) {
            this.donationQuantity.innerHTML = '0x'
        }
        // If donations are selected again, set default quantity to correct value.
        if (toggleChecked) {
            const multiplier = this.donationQuantity.dataset.quantityStored
                ? this.donationQuantity.dataset.quantityStored
                : '1'
            this.donationQuantity.innerHTML = `${multiplier}x`
        }
        formData.append('quantity', this.donationQuantity?.innerHTML)

        // Custom event for 'cart.js' to listen for, so basket totals get updated with donation.
        const eventMakeDonation = new CustomEvent('MakeDonation', {
            detail: {
                toggleChecked: toggleChecked, // Show loader when +/- pressed
                resetDonation: resetDonation
            }
        })

        axios({
            method: 'post',
            url: '/api/cart/update-donation-quantity/',
            data: formData,
            header: config.axiosHeader
        })
            .then((response) => {
                eventMakeDonation.detail.cartResponse = response.data.cart
                this.el.dispatchEvent(eventMakeDonation)
                this.errorContainer.innerHTML = ''
            })
            .catch((error) => {
                handleError(error, error?.response?.data, this.errorContainer, false)
            })
    }
}
